import { useCallback, useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeXmark, faVolumeHigh, faPlus, faStopwatch } from '@fortawesome/free-solid-svg-icons';

import style from './TallyCounter.module.css';

import CounterSingle from "./CounterSingle";

function TallyCounter() {
  const [counterItems, setCounterItems] = useState(() => {
    const saved = window.localStorage.getItem('zdt-tally-counter_items');
    return saved
      ? JSON.parse(saved)
      : [
          {
            id: 1,
            name: 'Counter 1',
            start: 0,
            count: 0
          }
        ];
  });

  const [toggleSound, setToggleSound] = useState(false);

  // const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;

  const addCounterHandler = () => {
    setCounterItems((previousState) => {
      let theNewId = 1;
      return [
        ...previousState,
        {
          id: theNewId = isFinite(Math.max(...previousState.map(o => o.id))) ? Math.max(...previousState.map(o => o.id)) + 1 : 1,
          name: `Counter ${theNewId}`,
          start: 0,
          count: 0
        }
      ];
    });
  };

  const toggleSoundHandler = () => {
    setToggleSound((previousState) => !previousState);
  };
  
  const removeCounterHandler = useCallback((id) => {
    const newCounterItems = counterItems.filter(function( obj ) {
      return obj.id !== parseInt(id);
    });

    setCounterItems(newCounterItems);
  }, [counterItems]);

  const counterNameChangeHandler = useCallback((id, name) => {
    const newCounterItems = counterItems.map(obj => {
      if (obj.id === id) {
        return {...obj, name: name};
      }
    
      return obj;
    });

    setCounterItems(newCounterItems);
  }, [counterItems]);

  const counterCountChangeHandler = useCallback((id, c) => {
    const newCounterItems = counterItems.map(obj => {
      if (obj.id === id) {
        return {...obj, count: c};
      }
    
      return obj;
    });

    setCounterItems(newCounterItems);
  }, [counterItems]);

  useEffect(() => {
    window.localStorage.setItem('zdt-tally-counter_items', JSON.stringify(counterItems));
  }, [counterItems]);

  useEffect(() => {
    const onStorage = () => {
      const saved = localStorage.getItem('zdt-tally-counter_items');
      if (saved) setCounterItems(JSON.parse(saved));
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <>
      <div className={style['content-wrap']}>
        <div>
          <div className={style.actions}>
            <span className={style['action-item']}>
              <button className="button button-gray button-xs button-icon_only" onClick={toggleSoundHandler}>
                {
                  toggleSound ? 
                  (<FontAwesomeIcon className="icon" icon={faVolumeHigh} />) :
                  (<FontAwesomeIcon className="icon" icon={faVolumeXmark} />)
                }
              </button>
            </span>
            <span className={style['action-item']}>
              <button className="button button-gray button-xs button-icon_only" onClick={addCounterHandler}><FontAwesomeIcon className="icon" icon={faPlus} /></button>
            </span>
          </div>
          <div className={style['zdt-item-countainer']}>
            {
              counterItems.map((data) => {
                return <div key={data.id}>
                  <CounterSingle
                    itemId={data.id}
                    name={data.name}
                    startingCount={data.count} 
                    removeItem={removeCounterHandler}
                    enableSound={toggleSound}
                    nameChange={counterNameChangeHandler}
                    countChange={counterCountChangeHandler}
                  ></CounterSingle>
                </div> 
              })
            }
            <div className={style['action-add-2']}>
              <button onClick={addCounterHandler}>
                <FontAwesomeIcon className={`icon ${style.icon}`} icon={faStopwatch} /> 
                <span className={style.text}>Add new counter</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TallyCounter;
